import { api } from "./api";
const basePath = "/company";

export const createCompany = async ({ values }: any) => {
  try {
    const res = await api.post(`${basePath}`, {
      values,
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const deleteCompanyById = async ({ id }: any) => {
  try {
    const res = await api.delete(`${basePath}`, {
      data: { _id: id },
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const getAddressList = async () => {
  try {
    const res = await api.get(`${basePath}/addresses`);
    return res;
  } catch (error) {
    return error;
  }
};

export const getCompaniesList = async ({
  pageNumber,
  limit,
  sort,
  address,
  code,
  name,
}: {
  pageNumber?: number;
  limit?: number;
  sort?: string;
  address?: string;
  code?: string;
  name?: string;
}) => {
  try {
    const params: Record<string, any> = {};
    if (pageNumber !== undefined) params.pageNumber = pageNumber;
    if (limit !== undefined) params.limit = limit;
    if (sort !== undefined) params.sort = sort;
    if (address !== undefined) params.address = address;
    if (code !== undefined) params.code = code;
    if (name !== undefined) params.name = name;

    const res = await api.get(`${basePath}/list`, { params });
    return res;
  } catch (error) {
    return error;
  }
};

export const updateCompanyById = async ({ updates, companyId }: any) => {
  try {
    const res = await api.put(`/company`, {
      _id: companyId,
      ...updates,
    });
    return res;
  } catch (error) {
    console.error("Error updating user:", error);
    return error;
  }
};

export const getCompanyById = async (id: string) => {
  try {
    const res = await api.get(`/company?_id=${id}`);
    return res;
  } catch (error) {
    return error;
  }
};

export const uploadCompanyPhoto = async (formData: any, type: any) => {
  try {
    const res = await api.post(`/photo/upload?type=${type}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return res;
  } catch (error) {
    console.error("Error uploading photo:", error);
    return error;
  }
};

export const getCompanyPhoto = async (companyId: any, type: any) => {
  try {
    const res = await api.get(`/photo?companyId=${companyId}&type=${type}`, {
      responseType: "blob",
    });
    return res;
  } catch (error) {
    return error;
  }
};
